<template>
    <div class="animated fadeIn equipmentList bgV2">
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    :data="tabData">
                    <template slot="gofixTab:right">
                        <template>
                            <gofix-button
                                class="ml-2"
                                :disabled="!$checkRole($accessModule.allow_endorse_incoming, 'allow_endorse_incoming')"
                                @click="endorse"
                                label="Endorsed"
                                v-if="item && item.file_type == 'DORJ'"
                                outline>
                            </gofix-button>
                            <gofix-button
                                class="ml-2"
                                :disabled="!$checkRole($accessModule.allow_endorse_incoming, 'allow_endorse_incoming')"
                                @click="endorseInvoice"
                                label="Endorsed"
                                v-if="item && item.file_type == 'INVOICE'"
                                outline>
                            </gofix-button>
                        </template>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <gofix-card fullContent v-bind:class="{'run-loading': loading}">
                            <div class="mt-25 pl-20 pr-20">
                                <b-row>
                                    <b-col md="3">
                                        <div class="d-flex field-display-basic mb-10">
                                            <span class="label">BATCH NUMBER</span>
                                            <span class="value">{{ item ? item.batch_no : '' }}</span>
                                        </div>
                                    </b-col>
                                    <b-col md="3">
                                        <div class="d-flex field-display-basic mb-10">
                                            <span class="label">BATCH DATE</span>
                                            <span class="value">{{ item ? item.batch_date : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}</span>
                                        </div>
                                    </b-col>
                                    <b-col md="3">
                                        <div class="d-flex field-display-basic">
                                            <span class="label">FILE NAME</span>
                                            <span class="value">{{ item ? item.file_name : '' }}</span>
                                        </div>
                                    </b-col>
                                    <b-col md="3">
                                        <div class="d-flex field-display-basic">
                                            <span class="label">FILE TYPE</span>
                                            <span class="value">{{ item ? item.file_type : '' }}</span>
                                        </div>
                                    </b-col>
                                    <b-col md="3">
                                        <div class="d-flex field-display-basic">
                                            <span class="label">SUBMIT BY</span>
                                            <span class="value">{{ item.submitted_by ? item.submitted_by.name : '' }}</span>
                                        </div>
                                    </b-col>
                                    <b-col md="3">
                                        <div class="d-flex field-display-basic">
                                            <span class="label">SUBMITTED ON</span>
                                            <span class="value">{{ item ? item.created_at : '' | formatDatebyMoment("YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm")  }}</span>
                                        </div>
                                    </b-col>
                                </b-row>
                            </div>
                        </gofix-card>
                        <gofix-card fullContent>
                            <gofix-table
                                :settings="tableConfig"
                                :table-items="tableItems"
                                @load-items="getTableData"
                                @delete-items="deleteItems"
                                @import-items="importItems"
                                @change-selected="setSelectedItems"
                                ref="gofixTable">
                                <template slot="gofix_table:actions" slot-scope="row" v-if="item && item.file_type == 'DORJ' && row.item.status && row.item.status != 'Accepted'">
                                    <b-form-checkbox disabled></b-form-checkbox>
                                </template>
                                <template slot="gofix_table:actions" slot-scope="row" v-if="item && item.file_type == 'INVOICE' && row.item.status && row.item.status != 'Invoiced'">
                                    <b-form-checkbox disabled></b-form-checkbox>
                                </template>
                                <template slot="gofix_table:document_date" slot-scope="row">
                                    {{ row.item.document_date ? row.item.document_date : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                                </template>
                                <template slot="gofix_table:replacement_date" slot-scope="row">
                                    {{ row.item.replacement_date ? row.item.replacement_date : '' | formatDatebyMoment("YYYY-MM-DD","DD.MM.YYYY") }}
                                </template>
                                <template slot="gofix_table:attachments" slot-scope="row">
                                    <div v-if="row.item.document.attachments.length > 0" class="attachmentsColumn" @click.stop="doThisImages(row.item.document.attachments)">
                                        <div class="items">
                                            <viewer-image :images="row.item.document.attachments" :showImage="true">
                                                <template slot="gofixViewer:list_image" slot-scope="{images}">
                                                    <div class="item" v-for="attachment in images">
                                                        <div class="item-content position-relative" @click="downloadFile(attachment)">
                                                            <span class="icon" v-html="$options.filters.iconFile(attachment, icons, true)"></span>
                                                            <span class="name">{{attachment.image_file_title || attachment.image_file_name}}</span>
                                                            <!-- <img class="image-viewer" v-if="checkShowImage(attachment.image_content_type)" v-auth-image="attachment.url.original" :key="attachment.url.original"  src="img/loading.gif"> -->
                                                        </div>
                                                    </div>
                                                </template>
                                            </viewer-image>
                                        </div>
                                    </div>
                                </template>
                                <template slot="gofix_table:unit_price" slot-scope="row">
                                    {{ `${$accounting.formatMoney(row.item.unit_price)}` }}
                                </template>
                                <template slot="gofix_table:discount" slot-scope="row">
                                    {{ `${$accounting.formatMoney(row.item.discount)}` }}
                                </template>
                                <template slot="gofix_table:total_price" slot-scope="row">
                                    {{ `${$accounting.formatMoney(row.item.total_price)}` }}
                                </template>
                                <template slot="gofix_table:gst" slot-scope="row">
                                    {{ `${$accounting.formatMoney(row.item.gst)}` }}
                                </template>
                                <template slot="gofix_table:document_number" slot-scope="row">
                                    <router-link class="text-dark" target="_blank" :to="`/v2/parts-replacement/${row.item.incoming_document_id}`">
                                        <span class="text-decoration-underline">{{ row.item.document_number }}</span>
                                    </router-link>
                                </template>
                            </gofix-table>
                        </gofix-card>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <b-modal :no-close-on-backdrop="true" id="modal-Remove" :title="''" hide-footer hide-header :centered="true" v-model="modals.warning.open">
            <div class="center">
            Proceed with the endorsement of this document?
            </div>
            <b-button-group class="btn-group">
                <b-button class="custom-btn" @click="modals.warning.open = false">No</b-button>
                <b-button class="custom-btn" @click="submit" :disabled="modals.warning.loading">
                    <b-spinner v-if="modals.stamping.loading" small type="grow"></b-spinner>Yes
                </b-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" title="Document Stamping Details" hide-footer :centered="true" v-model="modals.stamping.open">
            <b-form>
                <gofix-form-dropdown 
                    label="Replacement" 
                    :clearable="false" 
                    :filterable="false" 
                    :reduce="option => option.name"
                    v-model="modals.stamping.replacementModel" 
                    :options="replacementOption" 
                    vLabel="name" 
                    @search="searchReplacement">
                </gofix-form-dropdown>
                <div class="custom-checkbox-device">
                    <b-form-radio-group 
                        :options="[{ text: 'Normal', value: 'Normal' },{ text: 'Cyclical', value: 'Cyclical' }]" 
                        value-field="value"
                        text-field="text"
                        v-model="modals.stamping.type"
                        name="radio-inline" />
                </div>
            </b-form>
            <b-button-group class="d-block text-right p-1rem pt-0">
                <gofix-button :loading="modals.stamping.loading" label="APPLY STAMP" @click="submit" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-Create" :title="modals.process.title" hide-footer :centered="true" v-model="modals.process.open" hide-header-close>
            <b-progress :max="100" height="3rem" show-progress animated>
            <b-progress-bar :value="100">
                <span class="font-size-16">{{modals.process.text}}</span>
            </b-progress-bar>
            </b-progress>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import { filters } from '@/_filterVar.js'
    const ViewerImage = () => import('../../plugins/ViewerImage.vue')
    import { PDFDocument } from 'pdf-lib';
    import jsPDF from 'jspdf'; 
    import { defineStampInsertPdf } from "@/_commonVar.js";
    import moment from 'moment';

    export default {
        name: 'batch-submission-summary-detail',
        components: { 
            ViewerImage
        },
        data() {
            let filter = JSON.parse(JSON.stringify(filters['batch_submission_summary_detail']));
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    }
                ],
                tableConfig:{
                    name: 'table-incoming-documents-detail',
                    controls:{
                        create: false,
                        update: true,
                        delete: false,
                        tableImport: false,
                        tableExport: false,
                        tableColumnSettings: false,
                        reload: true,
                        tablePagination: true,
                        tableFilter: true
                    },
                    filter: filter,
                    page: 1,
                    limit: 100,
                    sortColumn: "id",
                    sortDirection: "asc",
                    fields: [
                        {
                            key: 'actions',
                            label: '',
                            thClass: 'checkbox-column text-center',
                            tdClass: 'checkbox-column text-center',
                            width: 50,
                            thStyle: "width:50px",
                        },
                        {
                            key: 'document_number',
                            label: 'Document Number',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'document_date',
                            label: 'Document Date',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 150px",
                        },
                        {
                            key: 'status',
                            label: 'Status',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 100px",
                        },
                        {
                            key: 'contract_name',
                            label: 'Town Council',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'block_number',
                            label: 'Blk No',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 100px",
                        },
                        {
                            key: 'lift_number',
                            label: 'Lift No',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 100px",
                        },
                        {
                            key: 'address',
                            label: 'Address',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 300px",
                        },
                        {
                            key: 'sor_code',
                            label: 'SOR Code',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 150px",
                        },
                        {
                            key: 'sor_description',
                            label: 'Description',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 300px",
                        },
                        {
                            key: 'unit_price',
                            label: 'Unit Price',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width: 100px",
                        },
                        {
                            key: 'discount',
                            label: 'Discount',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width: 100px",
                        },
                        {
                            key: 'gst',
                            label: 'GST',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width: 100px",
                        },
                        {
                            key: 'total_price',
                            label: 'Total Price',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-right',
                            tdClass: 'text-right',
                            thStyle: "width: 150px",
                        },
                        {
                            key: 'replaced_location',
                            label: 'Replacement Location',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'replacement_date',
                            label: 'Replacement Date',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'attachments',
                            label: 'Attachments (Link)',
                            isActive: 1,
                            isFilter: true,
                            sorting: true,
                            thClass: 'text-left',
                            tdClass: 'text-left',
                            thStyle: "width: 200px",
                        },
                        {
                            key: 'auto',
                            label: '',
                            isActive: 1,
                            isFilter: false,
                            sorting: false,
                            thClass: 'text-center',
                            tdClass: 'text-center'
                        },
                    ]
                },
                tableItems: [],
                item: [],
                loading: false,
                statusBatchHeader: false,
                images:[],
                icons: {
                    'application': {
                        'word': {
                            'img': 'word.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094ZM9.28301 8.29688H8.71699C8.62031 8.29688 8.53594 8.36191 8.51309 8.45684L7.63945 11.9531L6.8291 8.46035C6.80625 8.36543 6.72187 8.29688 6.62344 8.29688H6.00117C5.96884 8.29693 5.93695 8.3044 5.90795 8.31871C5.87896 8.33303 5.85364 8.3538 5.83395 8.37945C5.81425 8.40509 5.8007 8.43491 5.79434 8.46661C5.78798 8.49831 5.78898 8.53105 5.79727 8.5623L7.10156 13.4139C7.12617 13.5053 7.21055 13.5703 7.30547 13.5703H7.86797C7.96289 13.5703 8.04727 13.507 8.07188 13.4139L9 9.95098L9.92812 13.4139C9.95273 13.5053 10.0371 13.5703 10.132 13.5703H10.691C10.7859 13.5703 10.8703 13.507 10.8949 13.4139L12.2027 8.5623C12.2109 8.53105 12.2119 8.49834 12.2055 8.46667C12.1991 8.43499 12.1856 8.4052 12.1659 8.37958C12.1462 8.35396 12.1209 8.33318 12.0919 8.31885C12.063 8.30451 12.0311 8.29699 11.9988 8.29688H11.373C11.2746 8.29688 11.1902 8.36543 11.1674 8.46035L10.3623 11.9602L9.48691 8.45684C9.46406 8.36191 9.37969 8.29688 9.28301 8.29688Z" fill="#666666"/></svg>'
                        },
                        'excel': {
                            'img': 'excel.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125ZM12.0492 13.5961L10.6008 11.1961C10.5492 11.1117 10.4578 11.0602 10.3594 11.0602H9.45938C9.40547 11.0602 9.35391 11.0742 9.30938 11.1047C9.17813 11.1867 9.13828 11.3602 9.22266 11.4937L11.1516 14.55L9.19687 17.6625C9.17032 17.7052 9.15565 17.7542 9.15438 17.8045C9.15312 17.8547 9.1653 17.9044 9.18968 17.9484C9.21405 17.9923 9.24973 18.029 9.29303 18.0546C9.33632 18.0801 9.38566 18.0937 9.43594 18.0938H10.2445C10.343 18.0938 10.432 18.0422 10.4836 17.9602L11.9531 15.5812L13.4133 17.9578C13.4648 18.0422 13.5562 18.0914 13.6523 18.0914H14.5312C14.5852 18.0914 14.6367 18.075 14.6836 18.0469C14.8148 17.9625 14.8523 17.7891 14.768 17.6578L12.7992 14.6016L14.7984 11.4961C14.8255 11.4535 14.8407 11.4045 14.8423 11.3541C14.844 11.3037 14.8322 11.2537 14.808 11.2095C14.7838 11.1652 14.7482 11.1282 14.7049 11.1024C14.6616 11.0765 14.6122 11.0628 14.5617 11.0625H13.725C13.6266 11.0625 13.5352 11.1141 13.4836 11.1984L12.0492 13.5961Z" fill="#666666"/></svg>'
                        },
                        'pdf': {
                            'img': 'pdf.png',
                            'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.33926 10.0969L9.34453 10.0723C9.44648 9.65215 9.5748 9.12832 9.47461 8.65371C9.40781 8.2793 9.13184 8.1334 8.89629 8.12285C8.61855 8.11055 8.3707 8.26875 8.30918 8.49902C8.19316 8.9209 8.29688 9.49746 8.48672 10.2322C8.24766 10.8018 7.86621 11.6297 7.58672 12.1219C7.06641 12.3908 6.36855 12.8057 6.26484 13.3295C6.24375 13.4262 6.26836 13.5492 6.32637 13.66C6.39141 13.783 6.49512 13.8779 6.61641 13.9236C6.66914 13.943 6.73242 13.9588 6.80625 13.9588C7.11563 13.9588 7.6166 13.7092 8.28457 12.5631C8.38652 12.5297 8.49199 12.4945 8.59395 12.4594C9.07207 12.2977 9.56777 12.1289 10.016 12.0533C10.5117 12.3188 11.076 12.4893 11.4592 12.4893C11.8389 12.4893 11.9883 12.2643 12.0445 12.1289C12.143 11.8916 12.0955 11.5928 11.9355 11.4328C11.7035 11.2043 11.1393 11.1445 10.2604 11.2535C9.82793 10.9898 9.54492 10.6313 9.33926 10.0969ZM7.41094 12.767C7.1666 13.1221 6.98203 13.2996 6.88184 13.377C6.99961 13.1607 7.22988 12.9322 7.41094 12.767ZM8.95078 8.62734C9.04219 8.78379 9.02988 9.25664 8.95957 9.4957C8.87344 9.1459 8.86113 8.6502 8.91211 8.59219C8.92617 8.59395 8.93848 8.60449 8.95078 8.62734ZM8.92266 10.7455C9.11074 11.0707 9.34805 11.3502 9.60996 11.5576C9.23027 11.6438 8.88398 11.7861 8.57461 11.9127C8.50078 11.9426 8.42871 11.9725 8.3584 12.0006C8.59219 11.577 8.7873 11.0971 8.92266 10.7455ZM11.6578 11.8969C11.6596 11.9004 11.6613 11.9057 11.6508 11.9127H11.6473L11.6438 11.918C11.6297 11.9268 11.4855 12.0111 10.865 11.7668C11.5787 11.7334 11.6561 11.8951 11.6578 11.8969ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                        },
                    },
                    'image': {
                        'img': 'image.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.72246 8.94902L8.35488 10.6928L7.63242 9.77168C7.61927 9.75487 7.60246 9.74128 7.58327 9.73193C7.56409 9.72258 7.54302 9.71772 7.52168 9.71772C7.50034 9.71772 7.47927 9.72258 7.46009 9.73193C7.4409 9.74128 7.42409 9.75487 7.41094 9.77168L5.65664 12.0076C5.64041 12.0283 5.63034 12.0532 5.62758 12.0794C5.62482 12.1056 5.62948 12.132 5.64104 12.1557C5.65259 12.1793 5.67056 12.1992 5.69291 12.2132C5.71525 12.2271 5.74106 12.2344 5.76738 12.2344H12.2344C12.3521 12.2344 12.4172 12.099 12.3451 12.0076L9.9457 8.94902C9.93237 8.93219 9.91541 8.91859 9.89608 8.90924C9.87675 8.89989 9.85555 8.89503 9.83408 8.89503C9.81261 8.89503 9.79142 8.89989 9.77209 8.90924C9.75276 8.91859 9.73579 8.93219 9.72246 8.94902ZM6.32812 7.76953C6.32812 7.95601 6.4022 8.13485 6.53407 8.26672C6.66593 8.39858 6.84477 8.47266 7.03125 8.47266C7.21773 8.47266 7.39657 8.39858 7.52843 8.26672C7.6603 8.13485 7.73438 7.95601 7.73438 7.76953C7.73438 7.58305 7.6603 7.40421 7.52843 7.27235C7.39657 7.14049 7.21773 7.06641 7.03125 7.06641C6.84477 7.06641 6.66593 7.14049 6.53407 7.27235C6.4022 7.40421 6.32812 7.58305 6.32812 7.76953ZM15.0223 5.07305L11.2395 1.29023C11.134 1.18477 10.9916 1.125 10.8422 1.125H3.375C3.06387 1.125 2.8125 1.37637 2.8125 1.6875V16.3125C2.8125 16.6236 3.06387 16.875 3.375 16.875H14.625C14.9361 16.875 15.1875 16.6236 15.1875 16.3125V5.47207C15.1875 5.32266 15.1277 5.17852 15.0223 5.07305ZM13.8902 5.73047H10.582V2.42227L13.8902 5.73047ZM13.9219 15.6094H4.07812V2.39062H9.38672V6.1875C9.38672 6.3833 9.4645 6.57109 9.60296 6.70954C9.74141 6.848 9.9292 6.92578 10.125 6.92578H13.9219V15.6094Z" fill="#666666"/></svg>'
                    },
                    'text': {
                        'img': 'notepad.png',
                        'svg': '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.0297 6.76406L14.9859 1.72031C14.8453 1.57969 14.6555 1.5 14.4562 1.5H4.5C4.08516 1.5 3.75 1.83516 3.75 2.25V21.75C3.75 22.1648 4.08516 22.5 4.5 22.5H19.5C19.9148 22.5 20.25 22.1648 20.25 21.75V7.29609C20.25 7.09687 20.1703 6.90469 20.0297 6.76406ZM18.5203 7.64062H14.1094V3.22969L18.5203 7.64062ZM18.5625 20.8125H5.4375V3.1875H12.5156V8.25C12.5156 8.51107 12.6193 8.76145 12.8039 8.94606C12.9885 9.13066 13.2389 9.23438 13.5 9.23438H18.5625V20.8125Z" fill="#666666"/><path d="M6.75 18H13.75V16.75H6.75V18ZM6.75 10.5V11.75H17.25V10.5H6.75ZM6.75 14.875H17.25V13.625H6.75V14.875Z" fill="#666666"/></svg>'
                    },
                    'inode': 'none'
                },
                modals:{
                    warning:{
                        loading:false,
                        open:false,
                        status: 'DORJ Endorsed'
                    },
                    stamping:{
                        loading:false,
                        open:false,
                        replacementModel:null,
                        type: null,
                        ids: [],
                        attachments: [],
                        timer:null
                    },
                    process: {
                        title: 'Endorse DORJ',
                        open: false,
                        text: null,
                    }
                },
                replacementOption:[],
                lastReplacementDates: [],
                userProfile: null,
                signatureImage: null,
                signatureImageUrl: null
            }
        },
        created() {
            this.loading = true
            this.getBatchHeader()
            this.setUserData()
        },
        computed: {
            ...mapGetters({
                ClientContractID: 'ContractController/ClientContractID',
            }),
        },
        watch: {
            // ClientContractID: function(val) {
            //     this.$refs.gofixTable.reloadTableItems();
            // }
            UserLogin: function(val){
                this.setUserData()
            }
        },
        filters: {
            iconFile(val, icons, is_svg = false) {
                let path = 'img/';
                let type_show = 'img';
                let extension = '';
                let type = val.type || val.image_content_type;

                if(is_svg) {
                    path = '';
                    type_show = 'svg';
                }
                if(val.type) extension = val.name.split('.')[1];

                let arrTemp = type.split('/');
                if(arrTemp && arrTemp.length == 2) {
                    let type = arrTemp[0];
                    if(!extension) extension = arrTemp[1];

                    if(type == 'application' || type == 'inode' || type == 'text') {
                        let key = 'pdf';
                        if(['docx', 'doc', 'vnd.openxmlformats-officedocument.wordprocessingml.document', 'msword'].includes(arrTemp[1])) key = 'word';
                        if(['xls', 'xlsx', 'vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'vnd.ms-excel'].includes(arrTemp[1])) key = 'excel';
                        if(['zip', 'x-empty', 'plain'].includes(arrTemp[1])) {
                            let extension = val.image_file_name.split('.')[1];
                            if(['doc', 'docx'].includes(extension)) key = 'word';
                            if(['xls', 'xlsx', 'csv'].includes(extension)) key = 'excel';
                        }
                        return `${path}${icons['application'][key][type_show]}`;
                    }

                    return `${path}${icons[type][type_show]}`;
                }
            }
        },
        methods: {
            async downloadFile(attachment) {
                let url = attachment.url.original;
                let params = {};
                params.url = url;
                params.image_file_name = attachment.image_file_name;
                await this.$store.dispatch("FileDownloadController/getFile", params)
                .then(response => {
                })
                .catch(err => {
                    this.$alertNotification("Can not download file", "danger");
                })
            },
            doThisImages: function (attachments) {
                this.images = attachments
            },
            async getTableData(callback) {
                
                const { tableRequest , resolve, reject } = await callback();

                /**/
                if ( this.statusBatchHeader == false ) {
                    const response = {
                        items: [],
                        total: 0
                    }
                    resolve(response);
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    return false;
                }

                /**/
                tableRequest.filter.id.value =  this.$route.params.id
                tableRequest.file_type = this.item.file_type
                
                await this.$store.dispatch("BatchSubmissionController/getIncomingDocuments", tableRequest)
                .then(response => {
                    this.tableItems = response.items;
                    this.tableConfig.total = response.total;
                    resolve(response);
                })
                .catch(err => { 
                    reject()
                })
            },
            async deleteItems(callback){ },
            async importItems(callback){ },
            async deleteItems(callback){ },
            async getBatchHeader(){

                let param = {
                    id: this.$route.params.id,
                }

                await this.$store.dispatch("BatchSubmissionController/getBatchHeader", param)
                .then(response => {
                    this.item = response
                    this.statusBatchHeader = true
                    this.$refs.gofixTable.reloadTableItems()
                    this.loading = false
                })
                .catch(err => {
                    this.loading = false
                })
            },
            setSelectedItems(ids) {
                this.modals.stamping.ids = Array.from(new Set(ids))
            },
            endorse() {
                if(!this.modals.stamping.ids.length) {
                    this.$alertNotification('Please select at least 1 item before endorse', 'danger')
                    return
                }

                let filter = this.tableItems.filter(item => this.modals.stamping.ids.includes(item.incoming_document_id) && item.status != 'Accepted')
                if(filter.length) {
                    return this.$alertNotification("Please select items with Accepted status", "danger")
                }
                
                this.modals.warning.open = true
            },
            submit() {
                if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }

                this.timer = setTimeout(async () => {
                    this.modals.stamping.open = false
                    this.modals.warning.open  = false
                    this.processTime();
                    this.processAddStamp()
                }, 300);
            },
            async endorseInvoice(){
                if(!this.modals.stamping.ids.length) {
                    this.$alertNotification('Please select at least 1 item before endorse', 'danger')
                    return
                }

                let filter = this.tableItems.filter(item => this.modals.stamping.ids.includes(item.incoming_document_id) && item.status != 'Invoiced')
                if(filter.length) {
                    return this.$alertNotification("Please select items with Invoiced status", "danger")
                }
                
                // this.endorseItem([], 'Invoice Endorsed');
                this.modals.warning.status = 'Invoice Endorsed'
                this.modals.warning.open = true
            },
            async searchReplacement(search, loading){
                loading(true)
                this.replacementOption = []
                if (this.modals.stamping.timer) {
                    clearTimeout(this.modals.stamping.timer);
                    this.modals.stamping.timer = null;
                }
                this.modals.stamping.timer = setTimeout(async () => {
                    try {
                        await this.getPartLocation(search);
                        await loading(false)
                    } catch(e) {
                        loading(false)
                    }
                }, 500);
            },
            async getPartLocation(search){
                let tableRequest = {
                    page: 1,
                    limit: 100,
                    total: 0,
                    useDatabaseView: false,
                    sortColumn: "id",
                    sortDirection: "desc",
                    filter: {
                        name : search
                    }
                };

                await this.$store.dispatch("PartReplacementController/getPartLocation", tableRequest)
                .then(response => {                        
                    this.replacementOption = response.items;
                })
            },
            addStamp(item, data) {
                return new Promise(async (resolve, reject) => {
                    
                    let params = {
                        url: item.url.original,
                        image_file_name: item.url.image_file_name,
                    };
                    
                    let response = await this.$store.dispatch("FileDownloadController/getFileNotDownload", params);
                    const existingPdfBytes = await response.arrayBuffer().then(buffer => buffer)
                    const pdfDoc = await PDFDocument.load(existingPdfBytes)

                    const pages = pdfDoc.getPages()
                    const firstPage = pages[0]

                    // let lines = [
                    //     { text: `${this.modals.stamping.replacementModel.toUpperCase()}`, font: 14, lineHeight: 14, fontWeight: 'bold' },//16
                    //     { text: `${this.modals.stamping.type.toUpperCase()} / ${postal_code}`, font: 14, lineHeight: 16, fontWeight: 'bold' },
                    //     { text: 'To: GM (Pasir Ris - Punggol TC)', font: 12, lineHeight: 13 },
                    //     { text: 'We confirm the completion of work(s),', font: 12, lineHeight: 13 },
                    //     { text: 'please issue Works Order.', font: 12, lineHeight: 16 },
                    //     { text: 'on behalf of GM (EMS)', font: 12, lineHeight: 13 },
                    //     { text: `${this.UserLogin.organization && this.UserLogin.organization.name ? this.UserLogin.organization.name : ''}`, font: 12, lineHeight: 13 },
                    // ]
                    
                    let lines = [];

                    /* check lenght gl code - 60010 Normal Repair / Escalator Non-Cyclical / LSS / ARD Repair */
                    let chart_of_account_name = this.glCode && this.glCode.chart_of_account ? this.glCode.chart_of_account.name : '';
                    let chart_of_account_name_final = '--';
                
                    chart_of_account_name_final = chart_of_account_name;
                    
                    let height_plus = 0;
                    let arr_ = chart_of_account_name.split(' / ');

                    /* 3 line - 4 array */
                    if ( arr_.length == 4 ) {
                        
                        chart_of_account_name_final = arr_[2] + ' / ' + arr_[3];

                        lines.push({ text: arr_[0] + ' /', font: defineStampInsertPdf.lines[0].text_style.font_size, lineHeight: defineStampInsertPdf.lines[0].text_style.line_height, fontWeight: defineStampInsertPdf.lines[0].text_style.font_weight});

                        lines.push({ text: arr_[1] + ' /', font: defineStampInsertPdf.lines[0].text_style.font_size, lineHeight: defineStampInsertPdf.lines[0].text_style.line_height, fontWeight: defineStampInsertPdf.lines[0].text_style.font_weight});

                        height_plus = 14;
                    }

                    /* 2 line - 2 array */
                    if ( arr_.length == 2 ) {
                        chart_of_account_name_final = arr_[1];

                        lines.push({ text: arr_[0] + ' /', font: defineStampInsertPdf.lines[0].text_style.font_size, lineHeight: defineStampInsertPdf.lines[0].text_style.line_height, fontWeight: defineStampInsertPdf.lines[0].text_style.font_weight});

                        height_plus = 7;
                    }

                    /* */
                    if ( chart_of_account_name.length >= 20 && arr_.length == 1 ) {
                        chart_of_account_name_final = '';

                        lines.push({ text: chart_of_account_name, font: defineStampInsertPdf.lines[0].text_style.font_size, lineHeight: defineStampInsertPdf.lines[0].text_style.line_height, fontWeight: defineStampInsertPdf.lines[0].text_style.font_weight});

                        height_plus = 7;
                    }

                    /* */
                    for (let i = 0; i < defineStampInsertPdf.lines.length; i++) {

                        let textInsert = defineStampInsertPdf.lines[i].text;

                        textInsert = textInsert.replace('__A__', chart_of_account_name_final);
                        textInsert = textInsert.replace('__B__', data.document ? data.document.job_type : '--');
                        textInsert = textInsert.replace('__C__', data.document ? data.document.gl_code : '--');
                        textInsert = textInsert.replace('__D__', data.contract_name);
                        textInsert = textInsert.replace('__DATE__', `${moment().format('DD/MM/YYYY')}`);

                        lines.push({ text: textInsert, font: defineStampInsertPdf.lines[i].text_style.font_size, lineHeight: defineStampInsertPdf.lines[i].text_style.line_height, fontWeight: defineStampInsertPdf.lines[i].text_style.font_weight});
                    }

                    let startingPositon = 50
                    let x = 50;
                    let y = 50;
                    let widthBorderOne = defineStampInsertPdf.border.border_width_01
                    let widthBorderTwo = defineStampInsertPdf.border.border_width_02
                    let radiusBorderOne = defineStampInsertPdf.border.border_radius_01
                    let heightBorderOne = defineStampInsertPdf.border.border_height_01 + height_plus
                    let heightBorderTwo = defineStampInsertPdf.border.border_height_02 + height_plus
                    let radiusBorderTwo = defineStampInsertPdf.border.border_radius_02

                    var doc = await new jsPDF("landscape");
                    doc.setTextColor( defineStampInsertPdf.text.color );
                    for(let i = 0; i < lines.length; i++) {
                        let item = lines[i];
                        doc.setFontSize(item.font);
                        doc.setFont(defineStampInsertPdf.text.font_family, defineStampInsertPdf.text.font_weight, item.fontWeight || 'normal');
                        // if(i === 0) {
                        //     if(this.modals.stamping.replacementModel.length > 21) {
                        //         let text = ''
                        //         let arrTmp = this.modals.stamping.replacementModel.split(" ");
                        //         let isFirstLine = false;
                        //         arrTmp.forEach(val => {
                        //             if((`${text} ${val}`).length < 17) {
                        //                 text += ` ${val}`;
                        //             } else {
                        //                 if(!isFirstLine) {
                        //                     text += ` ${moment().format('DD/MM/YYYY')}`
                        //                     isFirstLine = true
                        //                 }
                        //                 heightBorderOne += 6
                        //                 heightBorderTwo += 6
                        //                 doc.text(text.trim().toUpperCase(), x, startingPositon);
                        //                 startingPositon = startingPositon + item.lineHeight - 8
                        //                 text = val
                        //             }
                        //         })

                        //         if(text.length < 17) {
                        //             if(!isFirstLine) {
                        //                 text += ` ${moment().format('DD/MM/YYYY')}`
                        //                 isFirstLine = true
                        //             }
                        //             doc.text(text, x, startingPositon);
                        //             startingPositon = startingPositon + item.lineHeight - 8
                        //         }
                        //     } else {
                        //         doc.text(`${this.modals.stamping.replacementModel.toUpperCase()} ${moment().format('DD/MM/YYYY')}`.trim(), x, startingPositon);
                        //         startingPositon = startingPositon + item.lineHeight - 8
                        //     }
                        // } else {
                            doc.text(item.text, x, startingPositon);
                            startingPositon = startingPositon + item.lineHeight - 8
                        // }
                    }
                    doc.setFillColor(defineStampInsertPdf.border.border_color[0], defineStampInsertPdf.border.border_color[1], defineStampInsertPdf.border.border_color[2]);
                    doc.setDrawColor(defineStampInsertPdf.border.border_color[0], defineStampInsertPdf.border.border_color[1], defineStampInsertPdf.border.border_color[2]);
                    doc.setLineWidth(1);
                    doc.roundedRect(x - 5, y - 8, widthBorderOne, heightBorderOne, radiusBorderOne, radiusBorderOne, 'S')
                    doc.setLineWidth(3);
                    doc.roundedRect(x - 8, y - 11, widthBorderTwo, heightBorderTwo, radiusBorderTwo, radiusBorderTwo, 'S')
                    
                    /* add signature user */
                    if ( this.signatureImage && this.signatureImageUrl ) {

                        let paramsImg = {
                            url: this.signatureImageUrl,
                            image_file_name: this.signatureImage,
                        };

                        let arrSignatureImage = this.signatureImage.split('.')
                        let suffixImg = arrSignatureImage[arrSignatureImage.length - 1]

                        let responseImg = await this.$store.dispatch("FileDownloadController/getFileNotDownload", paramsImg);

                        let existingImg_ = await responseImg.arrayBuffer().then(buffer => buffer);
                        let existingImg = this.arrayBufferToBase64(existingImg_);

                        doc.addImage('data:image/jpeg;base64,' + existingImg, suffixImg, 105, 70 + height_plus, 15, 15);
                    }

                    let stampPDFBytes = doc.output('arraybuffer');
                    const [stamp] = await pdfDoc.embedPdf(stampPDFBytes);
                    const stampDims = stamp.scale(0.8);
                    firstPage.drawPage(stamp, {
                        ...stampDims,
                        x: defineStampInsertPdf.position_x,
                        y: defineStampInsertPdf.position_y,
                    });

                    // Stamp System Received Date
                    item.created_at = item.created_at ? new Date(item.created_at) : null;
                    item.created_at = moment(item.created_at).format('DD/MM/YYYY');

                    let sDate_lines = [];
                    sDate_lines.push({ text: 'System Received Date', font: defineStampInsertPdf.lines[3].text_style.font_size, lineHeight: defineStampInsertPdf.lines[3].text_style.line_height, fontWeight: defineStampInsertPdf.lines[3].text_style.font_weight});
                    sDate_lines.push({ text: ' ', font: defineStampInsertPdf.lines[3].text_style.font_size, lineHeight: defineStampInsertPdf.lines[3].text_style.line_height, fontWeight: defineStampInsertPdf.lines[3].text_style.font_weight});
                    sDate_lines.push({ text: item.created_at, font: defineStampInsertPdf.lines[3].text_style.font_size, lineHeight: defineStampInsertPdf.lines[3].text_style.line_height, fontWeight: defineStampInsertPdf.lines[3].text_style.font_weight});

                    let sDate_startingPositon = 50
                    let sDate_x = 50;
                    let sDate_y = 50;
                    let sDate_widthBorderOne = 53
                    let sDate_radiusBorderOne = 5
                    let sDate_heightBorderOne = 22

                    var sDate_doc = await new jsPDF("landscape");
                    sDate_doc.setTextColor( defineStampInsertPdf.text.color );

                    let sDate_x_ = sDate_x;
                    for(let i = 0; i < sDate_lines.length; i++) {

                        let item = sDate_lines[i];
                        sDate_doc.setFontSize(item.font);
                        sDate_doc.setFont(defineStampInsertPdf.text.font_family, defineStampInsertPdf.text.font_weight, item.fontWeight || 'normal');

                        sDate_doc.text(item.text, sDate_x_, sDate_startingPositon );
                        
                        sDate_startingPositon = sDate_startingPositon + item.lineHeight - 8
                        sDate_x_ = sDate_x_ + 5
                    }

                    sDate_doc.setFillColor(defineStampInsertPdf.border.border_color[0], defineStampInsertPdf.border.border_color[1], defineStampInsertPdf.border.border_color[2]);
                    sDate_doc.setDrawColor(defineStampInsertPdf.border.border_color[0], defineStampInsertPdf.border.border_color[1], defineStampInsertPdf.border.border_color[2]);
                    sDate_doc.setLineWidth(1);
                    sDate_doc.roundedRect(sDate_x - 5, sDate_y - 8, sDate_widthBorderOne, sDate_heightBorderOne, sDate_radiusBorderOne, sDate_radiusBorderOne, 'S')
                    sDate_doc.setLineWidth(3);

                    const [sDate_stamp] = await pdfDoc.embedPdf(sDate_doc.output('arraybuffer'));
                    const sDate_stampDims = sDate_stamp.scale(0.8);
                    firstPage.drawPage(sDate_stamp, {
                        ...sDate_stampDims,
                        x: 120,
                        y: 380,
                    });
                    
                    /* getPartReplacementHistory - Last Replacement Date */
                    if ( item.job_type && item.job_type == 'Cyclical' ) {
                        await this.getPartReplacementHistory(item.attachable_id)
                        
                        if ( this.lastReplacementDates && this.lastReplacementDates.length > 0) {
                            /* */
                        } else {
                            this.lastReplacementDates.push('Last Replacement Date: NA');
                        }
                        
                        let position_y_plus = this.lastReplacementDates.length * 14 + 22
                        let lDate_lines = [];
                        
                        this.lastReplacementDates.forEach(function(item) {
                            lDate_lines.push({ text: item, font: defineStampInsertPdf.lines[3].text_style.font_size, lineHeight: defineStampInsertPdf.lines[3].text_style.line_height, fontWeight: defineStampInsertPdf.lines[3].text_style.font_weight});
                        })

                        let lDate_startingPositon = 50
                        let lDate_x = 50;
                        let lDate_y = 50;

                        var lDate_doc = await new jsPDF("landscape");
                        lDate_doc.setTextColor( defineStampInsertPdf.text.color );

                        for(let i = 0; i < lDate_lines.length; i++) {

                            let item = lDate_lines[i];
                            lDate_doc.setFontSize(item.font);
                            lDate_doc.setFont(defineStampInsertPdf.text.font_family, defineStampInsertPdf.text.font_weight, item.fontWeight || 'normal');

                            lDate_doc.text(item.text, lDate_x, lDate_startingPositon );
                            
                            lDate_startingPositon = lDate_startingPositon + item.lineHeight - 6
                        }

                        const [lDate_stamp] = await pdfDoc.embedPdf(lDate_doc.output('arraybuffer'));
                        const lDate_stampDims = lDate_stamp.scale(0.8);
                        firstPage.drawPage(lDate_stamp, {
                            ...lDate_stampDims,
                            x: defineStampInsertPdf.position_x,
                            y: defineStampInsertPdf.position_y + parseInt(position_y_plus),
                        });
                    }

                    const pdfBytes = await pdfDoc.save()
                    resolve(pdfBytes)
                })
            },
            async processAddStamp() {
                const processAddStampPDF = new Promise(async (resolve, reject) => {
                    this.processTime('In the process of adding stamps to the pdf')
                    let ids = []
                    let attachments = [];
                    let items = this.tableItems.filter(item => this.modals.stamping.ids.includes(item.incoming_document_id));
                    if(items.length) {
                        for(let x = 0; x < items.length; x++){
                            let val = items[x];
                            if(!ids.includes(val.incoming_document_id) && val.document && val.document.attachments && val.document.attachments.length) {
                                ids.push(val.incoming_document_id)
                                let glCode = await this.getFmCode(val);
                                if(glCode) val.glCode = glCode;

                                for(let i = 0; i < val.document.attachments.length; i++){
                                    let item = val.document.attachments[i];
                                    
                                    item['job_type'] = (val.document && val.document.job_type) ? val.document.job_type : null;
                                    
                                    if ( item.image_content_type != 'application/pdf' ) {
                                        continue;
                                    }
                                    
                                    /* check file name dorj */
                                    // let fileName = item.image_file_name.replace('.pdf', '');
                                    // let arrFileName = fileName.split('-');
                                    
                                    // if ( val.document.dorj_number && (arrFileName && (arrFileName.length == 3 || (arrFileName.length == 4 && arrFileName[arrFileName.length-1].length == 2))) ) {
                                    //     let dorjNumber = arrFileName[1] + '/' + arrFileName[2];
                                        
                                    //     if ( val.document.dorj_number.toLowerCase() ==  dorjNumber.toLowerCase() ) {
                                            
                                    //         await this.addStamp(item, val).then(result => {
                                    //             attachments.push({
                                    //                 id: item.id,
                                    //                 reference_id: item.reference_id,
                                    //                 file: new File([new Blob([result])], item.image_file_name, {type: 'application/pdf'})
                                    //             })
                                    //         })
                                    //     }
                                    // }
                                    
                                    if ( val.document.status == 'Invoiced' && val.document.invoice_ref && item.attachment_type.reference_value_text && item.attachment_type.reference_value_text == 'Invoice document' ) {
                                        await this.addStamp(item, val).then(result => {
                                            attachments.push({
                                                id: item.id,
                                                reference_id: item.reference_id,
                                                file: new File([new Blob([result])], item.image_file_name, {type: 'application/pdf'})
                                            })
                                        })
                                    }
                                    
                                    if ( val.document.status == 'Accepted' && val.document.dorj_number && item.attachment_type.reference_value_text && item.attachment_type.reference_value_text == 'DORJ document' ) {
                                        await this.addStamp(item, val).then(result => {
                                            attachments.push({
                                                id: item.id,
                                                reference_id: item.reference_id,
                                                file: new File([new Blob([result])], item.image_file_name, {type: 'application/pdf'})
                                            })
                                        })
                                    }
                                }
                            }
                        }
                    }
                    
                    await resolve(attachments)
                });
                processAddStampPDF.then(attachments => {
                    this.processTime('In the process of endorse to item')
                    this.endorseItem(attachments);
                })
            },
            async endorseItem(attachments = []) {

                this.modals.warning.loading = true
                this.modals.stamping.loading = true

                let request = {
                    ids: this.modals.stamping.ids,
                    attachments: attachments,
                    status: this.modals.warning.status,
                }
                this.loadingSubmit = false
                this.$store.dispatch('LMUDORJController/endorseItem', request)
                .then(response => {
                    this.$alertNotification(this.$notificationV2('editing', 'lmu_dorj'))
                    this.processTime('Successful')
                    this.modals.process.open = false
                    this.modals.warning.open = false
                    this.modals.warning.loading = false
                    this.modals.stamping.loading = false
                    this.modals.stamping.ids = []
                    this.$refs.gofixTable.reloadTableItems()
                })
                .catch(err => {
                    this.processTime('An error has occurred')
                    this.modals.process.open = false
                    this.modals.warning.open = false
                    this.modals.warning.loading = false
                    this.modals.stamping.loading = false
                })
            },
            processTime(text = '') {
                this.modals.process.text = text

                this.modals.process.title = 'Endorse DORJ'
                if ( this.modals.warning.status == "Invoice Endorsed" ) {
                    this.modals.process.title =  'Endorse Invoice'
                }

                this.modals.process.open = true
            },
            async getFmCode(part_replacement) {
                if(!part_replacement || !part_replacement.document) return null
                return new Promise(async (resolve, reject) => {
                    let work_type = null;
                    if(part_replacement.document.job_type == 'Normal') work_type = 'Reactive'
                    if(part_replacement.document.job_type == 'Cyclical') work_type = 'Preventive'
                    await this.$store.dispatch("FmCodeController/getFmCodeItems",{
                        limit: 1,
                        page: 1,
                        contract_id: part_replacement.document.contract_id,
                        type: 'incoming-document',
                        filter: {
                            work_type: work_type,
                            service_category_name: part_replacement.document.part_category || null,
                            gl_code: part_replacement.document.gl_code || null
                        }
                    })
                    .then(response => {
                        resolve(response.items.length ? response.items[0] : null)
                    });
                })
            },
            async getPartReplacementHistory(id){
                await this.$store.dispatch("PartReplacementController/getDetailItems", { 'filter': {"id":{"type":"number","value":"","function":"=","with":[]},"part_number":{"type":"text","value":"","function":"ilike","with":[]},"description":{"type":"text","value":"","function":"ilike","with":[]},"replaced_location":{"type":"text","value":"","function":"ilike","with":[]},"replacement_date":{"type":"date","value":null,"function":">=","with":[]},"unit_price":{"type":"number","value":"","function":{"value":">=","text":"After number(>=)"},"with":[]},"quantity":{"type":"number","value":"","function":{"value":">=","text":"After number(>=)"},"with":[]},"total_value":{"type":"number","value":"","function":{"value":">=","text":"After number(>=)"},"with":[]},"last_replacement_date":{"type":"date","value":null,"function":">=","with":[]},"age":{"type":"text","value":"","function":"ilike","with":[]}}, 'limit': 100, 'page': 1, 'isCMS': 1, 'sortColumn': 'id', 'sortDirection': 'DESC', 'useDatabaseView': true, 'livs_transaction_id': id })
                .then(response => {  
                    this.lastReplacementDates = [];
                    if ( response.items ) {
                        response.items.forEach((item, i) => {
                            if ( item.lastReplaceDate ) {
                                this.lastReplacementDates.push( (i + 1) + '. Last Replacement Date: ' + moment(item.lastReplaceDate).format('DD/MM/YYYY'));
                            } else {
                                this.lastReplacementDates.push( (i + 1) + '. Last Replacement Date: NA');
                            }
                        });
                    }
                })
                .catch(err => {
                    this.$alertNotification("Can not load Part Replacement History", "danger");
                });
            },
            setUserData() {
                if(this.UserLogin && this.UserLogin.id) {
                    this.$store.dispatch('v2UserController/getUser', this.UserLogin.id)
                    .then(response => {
                        
                        this.signatureImage = null
                        this.signatureImageUrl = null

                        if ( response.data.data && response.data.data.signature_image && response.data.data.signature_image[0] ) {
                            this.signatureImageUrl = response.data.data.signature_image[0].url.thumb
                            this.signatureImage = response.data.data.signature_image[0].image_file_name
                        }
                    })
                    .catch(error => {})
                }
            },
            arrayBufferToBase64( buffer ) {
                var binary = '';
                var bytes = new Uint8Array( buffer );
                var len = bytes.byteLength;
                for (var i = 0; i < len; i++) {
                    binary += String.fromCharCode( bytes[ i ] );
                }
                return window.btoa( binary );
            }
        }
    }
</script>
